/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_CnhInputs */

const en_case_field_driver_cnh = /** @type {(inputs: Case_Field_Driver_CnhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver's license (CNH)`)
};

const pt_br2_case_field_driver_cnh = /** @type {(inputs: Case_Field_Driver_CnhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNH`)
};

/**
* | output |
* | --- |
* | "Driver's license (CNH)" |
*
* @param {Case_Field_Driver_CnhInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_cnh = /** @type {((inputs?: Case_Field_Driver_CnhInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_CnhInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_cnh(inputs)
	return pt_br2_case_field_driver_cnh(inputs)
});